import { useSelector } from "react-redux";
import { NavLink as Link, useLocation } from "react-router-dom";

import "style/css/header.min.css";

function Header() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const url = useLocation().pathname;
  const getActive = (path, current = url) => (current === path ? "active" : "");
  function toggleNav() {
    var nav = document.querySelector(".links-container");
    // var signUp = document.getElementById("sign-up");
    nav.classList.toggle("hidden");
    // signUp.classList.toggle("show");
  }
  const signUpOrProfile = isAuthenticated ? (
    <Link
      id="sign-up"
      className="sign-up-button block w-max mx-auto md:m-0"
      to="/logout"
    >
      Logout
    </Link>
  ) : (
    <Link
      id="sign-up"
      className="sign-up-button block w-max mx-auto md:m-0"
      to="/register"
    >
      Sign up
    </Link>
  );
  return (
    <header id="Header" className="h-16 flex justify-between">
      <div className="logo text-base">Farm App</div>
      <div className="bg-green w-screen md:w-2/3 md:flex md:justify-between links-container mt-2.5 hidden">
        <ul className="nav-links">
          <li>
            <Link to="/home" className={getActive("/")}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/find">Find</Link>
          </li>
          <li>
            <Link to="/post">Post</Link>
          </li>
        </ul>
        {signUpOrProfile}
      </div>
      <button id="nav-toggler" className="sign-up-button" onClick={toggleNav}>
        X
      </button>
    </header>
  );
}

export default Header;
